import { squawkQuery } from "@common/api/quoting/squawk"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"
import { requirePermission } from "@/lib/require-permission"
import { SquawkPaneRoute } from "@/routes/_layout/quoting_/squawks/-components/squawk-pane"

export const Route = createFileRoute(
  "/_layout/work-orders/$workOrderId/squawks/$squawkId",
)({
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(queryClient, "squawk:read", "/"),
  loader: ({ context: { queryClient }, params: { squawkId } }) =>
    queryClient.ensureQueryData(squawkQuery({ squawk_id: squawkId })),
  component: SquawkRoute,
})

function SquawkRoute(): React.ReactElement {
  const { squawkId } = Route.useParams()
  const { data: squawk } = useSuspenseQuery(
    squawkQuery({ squawk_id: squawkId }),
  )
  return <SquawkPaneRoute key={squawk.id} squawk={squawk} />
}
